<template>
  <div class="fever-download-page">
    <!-- Sezione superiore blu -->
    <section class="fever-header" :aria-label="$t('FeverDownload.header_aria')">
      <div class="container">
        <div class="logo-row text-center">
          <b-img
            src="/fever/logo-fever.png"
            :alt="$t('FeverDownload.logo_alt')"
            class="fever-logo"
          ></b-img>
        </div>
        <div class="content-row">
          <div class="text-content">
            <p class="hero-text">
              {{ $t('FeverDownload.hero_text_before') }}
              <strong>{{ $t('FeverDownload.febbre') }}</strong>
              {{ $t('FeverDownload.hero_text_middle') }}
              <strong>{{ $t('FeverDownload.dolore') }}</strong>
              {{ $t('FeverDownload.hero_text_after') }}
            </p>
          </div>
          <div class="mascot-container">
            <b-img
              src="/fever/lucky-logo.png"
              :alt="$t('FeverDownload.lucky_alt')"
              class="lucky-mascot"
            ></b-img>
          </div>
        </div>
      </div>
    </section>

    <!-- Sezione inferiore con nuvola -->
    <section class="fever-cloud-section" :aria-label="$t('FeverDownload.download_aria')">
      <div class="cloud-background">
        <img
          src="/fever/nuvola.svg"
          alt=""
          aria-hidden="true"
          class="cloud-svg"
        />
      </div>
      <div class="cloud-content">
        <h1 class="download-title">{{ $t('FeverDownload.scarica_app') }}</h1>
        <b-img
          src="/fever/super-lucky-logo.svg"
          :alt="$t('FeverDownload.super_lucky_alt')"
          class="super-lucky-logo"
        ></b-img>
        <div class="store-buttons">
          <a
            v-if="googlePlayUrl"
            :href="googlePlayUrl"
            target="_blank"
            rel="noopener noreferrer"
            :aria-label="$t('FeverDownload.google_play_aria')"
          >
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/it_badge_web_generic.png"
              :alt="$t('FeverDownload.google_play_alt')"
              class="google-badge"
            />
          </a>
          <a
            v-if="appStoreUrl"
            :href="appStoreUrl"
            target="_blank"
            rel="noopener noreferrer"
            :aria-label="$t('FeverDownload.app_store_aria')"
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              :alt="$t('FeverDownload.app_store_alt')"
              class="store-badge apple-badge"
            />
          </a>
        </div>
      </div>
    </section>

    <!-- Striscia verde -->
    <div class="green-stripe" aria-hidden="true"></div>
  </div>
</template>

<script>
export default {
  name: "FeverDownload",
  computed: {
    googlePlayUrl() {
      return process.env.VUE_APP_FEVER_GOOGLE_PLAY_URL || "";
    },
    appStoreUrl() {
      return process.env.VUE_APP_FEVER_APP_STORE_URL || "";
    }
  }
};
</script>

<style lang="scss" scoped>
.fever-download-page {
  height: calc(100vh - 30px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.fever-header {
  background-color: $secondary;
  padding: 1rem 1rem 0.5rem 1rem;
  flex: 52 0 0;
  display: flex;
  flex-direction: column;
}

.fever-header .container {
  max-width: 1200px;
  margin: 0 auto;
}

.logo-row {
  margin-bottom: 1.5rem;
  margin-top: 0;
}

.fever-logo {
  max-width: 130px;
  height: auto;
}

.content-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
  flex: 1;
}

.text-content {
  flex: 1;
  max-width: 400px;
}

.hero-text {
  color: #ffffff;
  font-size: 1.5rem;
  line-height: 1.4;
  margin: 0;
  text-align: left;
}

.hero-text strong {
  font-weight: 700;
}

.mascot-container {
  flex: 0 0 auto;
}

.lucky-mascot {
  max-width: 120px;
  height: auto;
}

.fever-cloud-section {
  flex: 48 0 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 0;
  background-color: $secondary;
}

.cloud-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.cloud-svg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}

.cloud-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 1rem;
}

.download-title {
  font-size: 30px;
  font-weight: 700;
  color: $secondary;
  margin-bottom: 1rem;
  text-transform: uppercase;
  width: 100%;
}

.super-lucky-logo {
  max-width: 100px;
  height: auto;
  margin-bottom: 1rem;
}

.store-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.google-badge {
  height: 52px;
  width: auto;
}

.apple-badge {
  height: 40px;
  width: auto;
  border-radius: 8px;
}

.green-stripe {
  height: 34px;
  background-color: #93D500;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .fever-download-page {
    height: calc(100vh - 68px);
  }

  .logo-row {
    margin-bottom: 1rem;
  }

  .hero-text {
    font-size: 1.1rem;
    text-align: center;
  }

  .content-row {
    flex-direction: column;
    text-align: center;
  }

  .lucky-mascot {
    max-width: 80px;
  }

  .download-title {
    font-size: 1.1rem;
  }

  .super-lucky-logo {
    max-width: 80px;
  }

  .google-badge {
    height: 40px;
  }

  .apple-badge {
    height: 32px;
  }
}

@media (max-width: 447px) {
  .fever-download-page {
    height: calc(100vh - 90px);
  }
}

@media (max-width: 311px) {
  .fever-download-page {
    height: calc(100vh - 95px);
  }
}
</style>
